import { currencyColumn, dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn, textColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";

const relationshipType = 'property';
const {pluralName, color, endpoint} = objectDefinition(relationshipType);
const columns = [
    primaryRelationshipColumn({column: 'id', endpoint, label: 'Address', required: true}),
    currencyColumn(),
    dateColumn({column: 'built_date', label: 'Construction Date'}),
];

const NewProperties = forwardRef(function NewProperties(props, ref) {
    return (
        <RapidReinvestmentSection
            type={relationshipType}
            columns={columns}
            {...props}
            ref={ref}
        />
    )
});

export {NewProperties};
